module.exports = __webpack_public_path__ + "static/media/2013_feb_fl_hosp.81db0ab2.jpg";